export const departments = [
  {
    name: 'Ain',
    code_insee: '01',
  },
  {
    name: 'Aisne',
    code_insee: '02',
  },
  {
    name: 'Allier',
    code_insee: '03',
  },
  {
    name: 'Alpes de Haute Provence',
    code_insee: '04',
  },
  {
    name: 'Alpes (Hautes)',
    code_insee: '05',
  },
  {
    name: 'Alpes Maritimes',
    code_insee: '06',
  },
  {
    name: 'Ardèche',
    code_insee: '07',
  },
  {
    name: 'Ardennes',
    code_insee: '08',
  },
  {
    name: 'Ariège',
    code_insee: '09',
  },
  {
    name: 'Aube',
    code_insee: '10',
  },
  {
    name: 'Aude',
    code_insee: '11',
  },
  {
    name: 'Aveyron',
    code_insee: '12',
  },
  {
    name: 'Bouches du Rhône',
    code_insee: '13',
  },
  {
    name: 'Calvados',
    code_insee: '14',
  },
  {
    name: 'Cantal',
    code_insee: '15',
  },
  {
    name: 'Charente',
    code_insee: '16',
  },
  {
    name: 'Charente Maritime',
    code_insee: '17',
  },
  {
    name: 'Cher',
    code_insee: '18',
  },
  {
    name: 'Corrèze',
    code_insee: '19',
  },
  {
    name: "Côte d'Or",
    code_insee: '21',
  },
  {
    name: "Côtes d'Armor",
    code_insee: '22',
  },
  {
    name: 'Creuse',
    code_insee: '23',
  },
  {
    name: 'Dordogne',
    code_insee: '24',
  },
  {
    name: 'Doubs',
    code_insee: '25',
  },
  {
    name: 'Drôme',
    code_insee: '26',
  },
  {
    name: 'Eure',
    code_insee: '27',
  },
  {
    name: 'Eure et Loir',
    code_insee: '28',
  },
  {
    name: 'Finistère',
    code_insee: '29',
  },
  {
    name: 'Gard',
    code_insee: '30',
  },
  {
    name: 'Garonne (Haute)',
    code_insee: '31',
  },
  {
    name: 'Gers',
    code_insee: '32',
  },
  {
    name: 'Gironde',
    code_insee: '33',
  },
  {
    name: 'Hérault',
    code_insee: '34',
  },
  {
    name: 'Ille et Vilaine',
    code_insee: '35',
  },
  {
    name: 'Indre',
    code_insee: '36',
  },
  {
    name: 'Indre et Loire',
    code_insee: '37',
  },
  {
    name: 'Isère',
    code_insee: '38',
  },
  {
    name: 'Jura',
    code_insee: '39',
  },
  {
    name: 'Landes',
    code_insee: '40',
  },
  {
    name: 'Loir et Cher',
    code_insee: '41',
  },
  {
    name: 'Loire',
    code_insee: '42',
  },
  {
    name: 'Loire (Haute)',
    code_insee: '43',
  },
  {
    name: 'Loire Atlantique',
    code_insee: '44',
  },
  {
    name: 'Loiret',
    code_insee: '45',
  },
  {
    name: 'Lot',
    code_insee: '46',
  },
  {
    name: 'Lot et Garonne',
    code_insee: '47',
  },
  {
    name: 'Lozère',
    code_insee: '48',
  },
  {
    name: 'Maine et Loire',
    code_insee: '49',
  },
  {
    name: 'Manche',
    code_insee: '50',
  },
  {
    name: 'Marne',
    code_insee: '51',
  },
  {
    name: 'Marne (Haute)',
    code_insee: '52',
  },
  {
    name: 'Mayenne',
    code_insee: '53',
  },
  {
    name: 'Meurthe et Moselle',
    code_insee: '54',
  },
  {
    name: 'Meuse',
    code_insee: '55',
  },
  {
    name: 'Morbihan',
    code_insee: '56',
  },
  {
    name: 'Moselle',
    code_insee: '57',
  },
  {
    name: 'Nièvre',
    code_insee: '58',
  },
  {
    name: 'Nord',
    code_insee: '59',
  },
  {
    name: 'Oise',
    code_insee: '60',
  },
  {
    name: 'Orne',
    code_insee: '61',
  },
  {
    name: 'Pas de Calais',
    code_insee: '62',
  },
  {
    name: 'Puy de Dôme',
    code_insee: '63',
  },
  {
    name: 'Pyrénées Atlantiques',
    code_insee: '64',
  },
  {
    name: 'Pyrénées (Hautes)',
    code_insee: '65',
  },
  {
    name: 'Pyrénées Orientales',
    code_insee: '66',
  },
  {
    name: 'Rhin (Bas)',
    code_insee: '67',
  },
  {
    name: 'Rhin (Haut)',
    code_insee: '68',
  },
  {
    name: 'Rhône',
    code_insee: '69',
  },
  {
    name: 'Saône (Haute)',
    code_insee: '70',
  },
  {
    name: 'Saône et Loire',
    code_insee: '71',
  },
  {
    name: 'Sarthe',
    code_insee: '72',
  },
  {
    name: 'Savoie',
    code_insee: '73',
  },
  {
    name: 'Savoie (Haute)',
    code_insee: '74',
  },
  {
    name: 'Paris (Dept.)',
    code_insee: '75',
  },
  {
    name: 'Seine Maritime',
    code_insee: '76',
  },
  {
    name: 'Seine et Marne',
    code_insee: '77',
  },
  {
    name: 'Yvelines',
    code_insee: '78',
  },
  {
    name: 'Sèvres (Deux)',
    code_insee: '79',
  },
  {
    name: 'Somme',
    code_insee: '80',
  },
  {
    name: 'Tarn',
    code_insee: '81',
  },
  {
    name: 'Tarn et Garonne',
    code_insee: '82',
  },
  {
    name: 'Var',
    code_insee: '83',
  },
  {
    name: 'Vaucluse',
    code_insee: '84',
  },
  {
    name: 'Vendée',
    code_insee: '85',
  },
  {
    name: 'Vienne',
    code_insee: '86',
  },
  {
    name: 'Vienne (Haute)',
    code_insee: '87',
  },
  {
    name: 'Vosges',
    code_insee: '88',
  },
  {
    name: 'Yonne',
    code_insee: '89',
  },
  {
    name: 'Belfort (Territoire de)',
    code_insee: '90',
  },
  {
    name: 'Essonne',
    code_insee: '91',
  },
  {
    name: 'Hauts de Seine',
    code_insee: '92',
  },
  {
    name: 'Seine Saint Denis',
    code_insee: '93',
  },
  {
    name: 'Val de Marne',
    code_insee: '94',
  },
  {
    name: "Val d'Oise",
    code_insee: '95',
  },
  {
    name: 'Guadeloupe',
    code_insee: '971',
  },
  {
    name: 'Martinique',
    code_insee: '972',
  },
  {
    name: 'Guyane',
    code_insee: '973',
  },
  {
    name: 'Réunion',
    code_insee: '974',
  },
  {
    name: 'Saint Pierre et Miquelon',
    code_insee: '975',
  },
  {
    name: 'Mayotte',
    code_insee: '976',
  },
  {
    name: 'Saint Barthélémy',
    code_insee: '977',
  },
  {
    name: 'Saint Martin',
    code_insee: '978',
  },
  {
    name: 'Terres australes/antarctiques',
    code_insee: '984',
  },
  {
    name: 'Wallis et Futuna',
    code_insee: '986',
  },
  {
    name: 'Polynésie française',
    code_insee: '987',
  },
  {
    name: 'Nouvelle Calédonie',
    code_insee: '988',
  },
  {
    name: 'Ile de Clipperton',
    code_insee: '989',
  },
  {
    name: 'Corse du Sud',
    code_insee: '2A',
  },
  {
    name: 'Haute Corse',
    code_insee: '2B',
  },
]

export const findDepartmentName = (department: string) =>
  departments.find((e) => e.code_insee === department)?.name ?? ''
